"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoSearchResultsMessage = exports.NoSearchResultsMessageWrapper = void 0;
var React = __importStar(require("react"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var styled_components_1 = __importDefault(require("styled-components"));
var contentConstants_1 = __importDefault(require("../../contentConstants"));
exports.NoSearchResultsMessageWrapper = styled_components_1.default.div.attrs({
    className: 'tws-no-results-message',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t {\n\t\ttext-align: ", ";\n\t\tpadding-top: 50px;\n\t\tpadding-bottom: 50px;\n\t}\n"], ["\n\t {\n\t\ttext-align: ", ";\n\t\tpadding-top: 50px;\n\t\tpadding-bottom: 50px;\n\t}\n"])), function (props) { return (props.textAlign ? props.textAlign : 'center'); });
exports.NoSearchResultsMessageWrapper.displayName = 'NoSearchResultsMessageWrapper';
var NoSearchResultsMessage = /** @class */ (function (_super) {
    __extends(NoSearchResultsMessage, _super);
    function NoSearchResultsMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoSearchResultsMessage.prototype.render = function () {
        return (React.createElement(exports.NoSearchResultsMessageWrapper, { textAlign: this.props.textAlign }, this.props.message ? (0, html_react_parser_1.default)(this.props.message) : contentConstants_1.default.SEARCH_NO_RESULTS_MESSAGE));
    };
    return NoSearchResultsMessage;
}(React.Component));
exports.NoSearchResultsMessage = NoSearchResultsMessage;
var templateObject_1;
